import React from "react";

import AlongLogo from "components/AlongLogo";
import BlurplePage from "ui/BlurplePage";
import Link from "ui/Link";
import Typography from "ui/Typography";

export default function StudentInvalidCode() {
  return (
    <BlurplePage className="d-flex flex-column align-items-center px-2">
      <div className="mb-4 mt-5">
        <AlongLogo size="large" />
      </div>
      <Typography
        size="h4"
        as="p"
        color="ColorWhite"
        className="mb-4"
        fontWeight="bold"
        textAlign="center"
      >
        Hmm... we don’t recognize this invite code. Try again or ask your
        teacher for a new link.
      </Typography>
      <Typography size="bodySansSerif" color="ColorWhite">
        Need help?{" "}
        <Link
          analyticsName="clicked_get_help"
          href="mailto:support@along.org"
          isOnDarkBackground={true}
        >
          Contact support.
        </Link>
      </Typography>
    </BlurplePage>
  );
}
